import {
  FETCH_GRAPH_ENERGY_FORECAST,
  FETCH_GRAPH_ENERGY_FORECAST_SUCCESS,
  FETCH_GRAPH_ENERGY_FORECAST_FAILURE,
} from 'actions/graphs';
import type { EnergyForecastResponse } from 'types/kbygApi';
import type { WaveEnergyGraphData } from 'types/waveEnergy';

import createReducer from '../../createReducer';
import createDayHourlyData from './helpers/createDayHourlyData';
import createFiveDayHourlyWave from './helpers/createFiveDayHourlyData';

export const initialState: WaveEnergyGraphData = {
  days: null,
  error: null,
  hourly: null,
  loading: true,
  utcOffset: null,
  location: null,
  forecastLocation: null,
  runInitializationTimestamp: null,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- matches graph reducers (e.g. consistency)
const handlers: any = {};

handlers[FETCH_GRAPH_ENERGY_FORECAST] = () => ({ ...initialState });

handlers[FETCH_GRAPH_ENERGY_FORECAST_SUCCESS] = (
  state: WaveEnergyGraphData,
  {
    desired16DayInterval,
    response,
  }: {
    response: EnergyForecastResponse;
    desired16DayInterval: 1 | 3;
  },
): WaveEnergyGraphData => {
  const {
    data: { energy },
    associated,
  } = response;

  if (!energy?.length) {
    return {
      ...state,
      loading: false,
      days: [],
      hourly: [],
      utcOffset: null,
      location: associated?.location ?? null,
      forecastLocation: associated?.forecastLocation ?? null,
      runInitializationTimestamp: associated?.runInitializationTimestamp ?? null,
    };
  }

  return {
    ...state,
    loading: false,
    days: createDayHourlyData(energy, 16, desired16DayInterval),
    hourly: createFiveDayHourlyWave(energy),
    utcOffset: energy[0]?.utcOffset ?? null,
    location: associated?.location ?? null,
    forecastLocation: associated?.forecastLocation ?? null,
    runInitializationTimestamp: associated?.runInitializationTimestamp ?? null,
  };
};

handlers[FETCH_GRAPH_ENERGY_FORECAST_FAILURE] = (
  state: WaveEnergyGraphData,
  { error }: { error: WaveEnergyGraphData['error'] },
): WaveEnergyGraphData => ({
  ...state,
  error,
  loading: false,
});

export default createReducer(handlers, initialState);
